import { ucFirst } from "../Services/helpers";

const dateRanges = {
    'allTime'         : 'All time',
    'lastYear'        : 'Last Year',
    'thisYear'        : 'This Year',
    'thisMonth'       : 'This Month',
    'lastMonth'       : 'Last Month',
    'lastThreeMonths' : 'Last 3 Months',
    'lastSixMonths'   : 'Last 6 Months',
    'thisWeek'        : 'This Week',
    'lastWeek'        : 'Last Week',
    'today'           : 'Today',
    'yesterday'       : 'Yesterday',
}

const periods = [
    'date',
    'week',
    'month',
    'year',
];

const selectableDateRanges = Object.keys(dateRanges).map(key => ({
    value: key,
    label: dateRanges[key],
}));

const selectablePeriods = periods.map(key => ({
    value: key,
    label: ucFirst(key),
}));

export {
    dateRanges,
    selectableDateRanges,
    periods,
    selectablePeriods,
};
